<script>
export default {
  data() {
    return {
      isHidden: true,
      selectedPreview: false,
    };
  },
  props: [
    'product_group',
    'isCheckboxShown',
    'index',
    'rights',
  ],
  watch: {
    product_group: {
      handler() {
        this.selectedPreview = this.product_group
          .filter((item) => item.selected)
          .length === this.product_group.length;
      },
      deep: true,
    },
  },
  computed: {
    goodConditions() {
      if (typeof this.product_group === 'undefined') return false;

      return this.product_group.reduce((acc, current) => {
        if (current.condition !== 0) return acc;
        return acc + current.ids.length;
      }, 0);
    },
    attentionConditions() {
      if (typeof this.product_group === 'undefined') return false;
      return this.product_group.reduce((acc, current) => {
        if (current.condition !== 2) return acc;
        return acc + current.ids.length;
      }, 0);
    },
    badConditions() {
      if (typeof this.product_group === 'undefined') return false;

      return this.product_group.reduce((acc, current) => {
        if (current.condition !== 1) return acc;
        return acc + current.ids.length;
      }, 0);
    },
    calcSize() {
      const isNaN = this.product_group.filter((product) => (
        product.dimensions === null || product.dimensions.volume === null
      )).length > 0;

      if (isNaN) {
        return 'NaN';
      }

      const calculatedSize = this.product_group.reduce((acc, current) => {
        if (current.dimensions !== null && current.dimensions.volume !== null) {
          const size = current.dimensions.volume * current.quantity;
          return acc + size;
        }

        return acc;
      }, 0);

      return `${calculatedSize.toFixed(2)}&nbsp;ft<sup>3</sup>`;
    },
    user_role() {
      return this.$store.state.users.role;
    },
    hasSlotButtonsProduct() {
      return !!this.$scopedSlots.buttonsProduct;
    },
    app_section() {
      return this.$store.getters.get_app_section;
    },
  },
  methods: {
    changeCondition(product) {
      this.$store.commit('set_modal_condition', { ...product });
    },
    editProducts(product) {
      this.$store.commit('set_modal_edit_products', { ...product });
    },
    showDeleteGroupModal(group) {
      let ids = null;

      const str = group.reduce((sum, item) => {
        if (typeof item.ids !== 'undefined') return sum + item.ids;

        return `${sum + item.id},`;
      }, '');

      ids = str.split(',');
      ids = ids.filter((item) => item.length > 0);

      this.$store.commit('set_modal_inform', {
        type: 'delete',
        action: 'isremove_products',
        action_data: ids,
        inform_message: {
          0: this.goodConditions,
          1: this.badConditions,
          2: this.attentionConditions,
        },
      });
    },
    showDeleteProductsModal(product, condition, quantity) {
      let ids = null;

      if (typeof product.ids !== 'undefined') {
        ids = product.ids;
      } else {
        ids = product.id;
      }

      const data = {
        type: 'delete',
        action: 'isremove_products',
        action_data: ids,
      };

      if (condition === 0) {
        data.inform_message = {
          [condition]: quantity,
        };
      }

      this.$store.commit('set_modal_inform', data);
    },
    isChildrenSelected(products) {
      const selectedItems = products.filter((subItem) => subItem.selected);
      this.selectedPreview = selectedItems.length === products.length;
    },
    setSelectedPreview(parent) {
      if (!this.selectedPreview) {
        parent.map((subItem) => {
          subItem.selected = false;
          return subItem;
        });
        return;
      }

      parent.map((subItem) => {
        subItem.selected = true;
        return subItem;
      });
    },
  },
};
</script>
<template src="./table_product_group.pug" lang="pug"></template>
